import { hasProperty } from '../../utilities/hasProperty';
const { parse, stringify } = JSON;
/**
 * convert width and fwhm to ppm
 */
export function convertWidth(peaks, options) {
    const { frequency, convertTo, output = parse(stringify(peaks)), } = options;
    const convert = getConverter(convertTo, frequency);
    for (const peak of output) {
        peak.width = convert(peak.width);
        if (hasProperty(peak, 'shape')) {
            const shape = peak.shape;
            if (shape.fwhm) {
                shape.fwhm = convert(shape.fwhm);
            }
        }
    }
    return output;
}
function getConverter(convertTo, frequency) {
    switch (convertTo) {
        case 'ppm':
            return (x) => x / frequency;
        case 'hz':
            return (x) => x * frequency;
        default:
            throw new Error(`Does not support convert to ${convertTo}`);
    }
}
//# sourceMappingURL=convertWidth.js.map